<template>
  <div class="border-b pb-2 mb-4">
    <div class="flex items-center space-x-3 mb-4">
      <EstatecomplyLogo class="w-48 h-auto" />
    </div>
    <div>
      <h2 class="text-xl font-semibold text-gray-900">{{ title }}</h2>
      <p class="text-sm text-gray-500">
        {{ $gettext("Créé le: ") }} {{ parseDate(date) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import EstatecomplyLogo from "@/components/assets/EstatecomplyLogo.vue";
import { useGettext } from "vue3-gettext";
import { useDate } from "@/utils/stores/date";

const { parseDate } = useDate();
const { $gettext } = useGettext();

defineProps({
  title: String,
  date: String
});
</script>
